module.exports = __webpack_public_path__ + "static/media/problembg.3e37111a.jpg";